import * as types from './types'
import { getShopifyClient } from '@/helpers/shop'
import { CHECKOUT_LOADING, UPDATE_CHECKOUT } from './types'
import { UPDATE_USER_INFORMATIONS } from '../user/types'
import { HYDRATE_THEME_WITH_SHOPIFY } from '@/store/modules/theme/types'

const axios = require('axios');

export default {
  [types.RESET_SHOP]: async function(store) {
    const client = getShopifyClient()

    const newCheckout = await client.checkout.create()

    store.commit(UPDATE_CHECKOUT, { checkout: newCheckout })
    store.dispatch(UPDATE_USER_INFORMATIONS, {
      checkoutId: newCheckout.id
    })
  },
  [types.INIT_SHOP]: async function(store) {
    const client = getShopifyClient()

    const user = store.rootState.user.userInformations
    if (!user) return

    if (client) {
      // Init cart
      const savedCheckoutId = user.checkoutId

      let checkout
      if (savedCheckoutId) {
        checkout = await client.checkout.fetch(savedCheckoutId)
        if (!checkout) { // unable to fetch the checkout, create it
          checkout = await client.checkout.create()
        }
      } else {
        checkout = await client.checkout.create()
      }

      store.dispatch(UPDATE_USER_INFORMATIONS, {
        checkoutId: checkout.id
      })

      // Init products - WARNING : the limit is 250
      const collections = await client.collection.fetchAllWithProducts({productsFirst: 250})
      let products = []
      collections.forEach(collection => {
        products = products.concat(collection.products)
      })
      const bottles = []
      const masterclasses = []
      products.forEach(product => {

        if (product.productType === 'Bouteille') {
          bottles.push(product)
        } else if (product.productType === 'Masterclass') 
        {
          masterclasses.push(product)

          // check if we find the masterclass linked
          const sku = product.variants[0].sku
          const productId = product.id

          if (sku) {
            // check if we have it in the store and then add it
            store.commit(HYDRATE_THEME_WITH_SHOPIFY, {
              masterclassId: sku,
              shopifyId: productId
            })
          }
        }
      })

      store.commit(types.INIT_SHOP, {
        checkout,
        bottles,
        masterclasses
      })
    }
  },
  [types.ADD_TO_CART]: async function(store, { quantity, variantId, typeProduct, giftData = {} }) {
    store.commit(CHECKOUT_LOADING, true)

    const customAttributes = [{
      key: "type",
      value: typeProduct.toString()
    }]

    // if the item is a gift
    if (giftData && typeof giftData == 'object' && Object.keys(giftData).length > 0) {
      customAttributes.push({
        key: "gift",
        value: JSON.stringify(giftData)
      })
    }

    try {
      const checkout = await getShopifyClient().checkout.addLineItems(store.state.checkout.id, [
        {
          variantId,
          quantity,
          customAttributes
        }
      ])

      store.commit(UPDATE_CHECKOUT, { checkout })
      return true
    } catch (error) {
      console.log('error', error)
      // Reset the shop
      store.dispatch(types.RESET_SHOP)
      return false
    }
  },
  [types.UPDATE_PRODUCT]: async function(store, { quantity, variantId, typeProduct, giftData = {} }) {
    const customAttributes = [{
      key: "type",
      value: typeProduct.toString()
    }]

    // if the item is a gift
    if (giftData && typeof giftData == 'object' && Object.keys(giftData).length > 0) {
      customAttributes.push({
        key: "gift",
        value: JSON.stringify(giftData)
      })
    }

    try {
      const checkout = await getShopifyClient().checkout.updateLineItems(store.state.checkout.id, [
        {
          id: variantId,
          quantity,
          customAttributes
        }
      ])

      store.commit(UPDATE_CHECKOUT, { checkout })
      return true
    } catch (error) {
      console.log('error', error)
      // Reset the shop
      store.dispatch(types.RESET_SHOP)
      return false
    }
  },
  [types.ADD_VOUCHER]: async function (store, code) {
    store.commit(CHECKOUT_LOADING, true)

    const checkout = await getShopifyClient().checkout.addDiscount(store.state.checkout.id, code)

    store.commit(UPDATE_CHECKOUT, { checkout })
  },
  [types.UPDATE_QUANTITY]: async function(store, { cartItem, quantity }) {
    store.commit(CHECKOUT_LOADING, true)
    let checkout

    try {
      if (quantity <= 0) {
        checkout = await getShopifyClient().checkout.removeLineItems(store.state.checkout.id, [
          cartItem.id
        ])
      } else {
        checkout = await getShopifyClient().checkout.updateLineItems(store.state.checkout.id, [
          {
            id: cartItem.id,
            quantity
          }
        ])
      }

      store.commit(UPDATE_CHECKOUT, { checkout })
    } catch (error) {
      console.log('error', error)
      // Reset the shop
      store.dispatch(types.RESET_SHOP)
    }
  },
  [types.UPDATE_CHECKOUT_INFORMATIONS]: async function(store, userInfo) {
    const shippingAddress = {
      address1: userInfo.shippingAddress,
      city: userInfo.shippingCity,
      firstName: userInfo.firstname,
      lastName: userInfo.lastname,
      phone: userInfo.phoneNumber,
      zip: userInfo.shippingPostalCode,
      country: 'France'
    }

    // Update the shipping address for an existing checkout.
    await getShopifyClient().checkout.updateShippingAddress(
      store.state.checkout.id,
      shippingAddress
    )

    const newCheckout = await getShopifyClient().checkout.updateEmail(
      store.state.checkout.id,
      userInfo.email
    )

    store.commit(UPDATE_CHECKOUT, { checkout: newCheckout })

    return newCheckout
  },
  [types.CREATE_GIFT_DISCOUNT]: async function(store, { variantId, title, price}) {
    const headers = { 
      'Content-Type': 'application/json', 
      'X-Shopify-Access-Token': process.env.VUE_APP_SHOPIFY_PASSWORD
    }

    // get number of discounts in the store
    let nbDiscountUrl = null
    if (process.env.VUE_APP_ENV == 'development')
      nbDiscountUrl = 'https://vinovibes-cors-anywhere.herokuapp.com/https://vino-dev2.myshopify.com/admin/api/2021-04/discount_codes/count.json'
    else nbDiscountUrl = 'https://vinovibes-cors-anywhere.herokuapp.com/https://vinovibes-fr.myshopify.com/admin/api/2021-04/discount_codes/count.json'
  
    const nbDiscountCodeResponse = await axios({
      method: 'get',
      url: nbDiscountUrl,
      headers: headers
    })
    
    // set discount code label
    let discountCode = null
    if ('count' in nbDiscountCodeResponse.data) discountCode = `${title.toUpperCase()}-${nbDiscountCodeResponse.data.count + 1}`
    else discountCode = `${title.toUpperCase()}-${Date.now()}`

    // generate price rule
    let priceRuleUrl = null
    if (process.env.VUE_APP_ENV == 'development')
      priceRuleUrl = 'https://vinovibes-cors-anywhere.herokuapp.com/https://vino-dev2.myshopify.com/admin/api/2021-04/price_rules.json'
    else priceRuleUrl = 'https://vinovibes-cors-anywhere.herokuapp.com/https://vinovibes-fr.myshopify.com/admin/api/2021-04/price_rules.json'

    const priceRuleResponse = await axios({
      method: 'post',
      url: priceRuleUrl,
      headers: headers,
      data: JSON.stringify({
        "price_rule": {
          "allocation_method": "across",
          "customer_selection": "all",
          "target_type": "line_item",
          "once_per_customer": true,
          "usage_limit": 1,
          "value": `-${price}`,
          "value_type": "fixed_amount",
          "title": discountCode,
          "target_selection": "entitled",
          "entitled_variant_ids": [
            variantId
          ],
          "starts_at": "2017-01-19T17:59:10Z",
          "prerequisite_quantity_range": {
            "greater_than_or_equal_to": 1
          }
        }
      })
    })

    // generate discount code
    if ('price_rule' in priceRuleResponse.data) {
      let priceRuleId = priceRuleResponse.data.price_rule.id
      
      let discountCodeUrl = null
      if (process.env.VUE_APP_ENV == 'development')
        discountCodeUrl = `https://vinovibes-cors-anywhere.herokuapp.com/https://vino-dev2.myshopify.com/admin/api/2021-04/price_rules/${priceRuleId}/discount_codes.json`
      else discountCodeUrl = `https://vinovibes-cors-anywhere.herokuapp.com/https://vinovibes-fr.myshopify.com/admin/api/2021-04/price_rules/${priceRuleId}/discount_codes.json`
    
      const discountCodeResponse = await axios({
        method: 'post',
        url: discountCodeUrl,
        headers: headers,
        data: JSON.stringify({
          "discount_code": {
            "code": discountCode
          }
        })
      })
      
      if ('discount_code' in discountCodeResponse.data) {
        return discountCodeResponse.data.discount_code
      } else {
        return null
      }
    } else {
      return null
    }
  }
}
